import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: {
      name: '',
      phone: '',
      rank: 0,
      joined: false,
      cash: 0,
      chancesLeft: ''
    },
    partner: '',
    wallet: {
      type: '',
    },
    gameName: '',
    game: '',
    headTitle: '',
    totalUserPoints: 0,
    countDownTimer: "00h:00m:00s",
    history: true,
    alert: false,
    alertText: "",
    refreshTournament: false,
    timer: "",
    showHeader: true,
    showHistory: true,
    showWallet: true,
    isInfo: false,
    shareText: "",
    refreshTournamentTimer: null,
    refreshMainPageTimer: null,
    redeem: false,
    requestedTR: false,
    success: false,
    processing: false,
    mainPageTournaments: [],
    mainPageLeaderboard: [],
    mainPagePrizes: [],
    timersArray: [],
    allTournamentsList: [],
    lang: '',
    bg_theme: "#666666"
  },
  getters: {
    gamesDomain: state => {
      var curr_domain = window.location.origin;
      console.log(curr_domain);
      if (curr_domain.includes("appbrowzer")) {
        return 'https://www.appbrowzer.com'
      } else {
        return 'https://ghc.theflyy.com/api'
      }
    },
    flyyDomain: state => {
      return 'https://ghc.theflyy.com/api'
    },
    headers: state => {
      var user = state.user;
      return {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      };
    }
  }
});

export default store


// WEBPACK FOOTER //
// ./src/store.js